import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom";
import "./i18n/i18n";
import { Provider } from "react-redux";
import store from "./redux/store";
import Loader from "./components/Loader/Loader";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback="loading...">
        <HashRouter>
          <Loader />
          <App />
        </HashRouter>
      </Suspense>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
